import React from 'react';
import './TeamCard.css';

const TeamCard = ({ name, onClick }) => {
  return (
    <div className="team-card" onClick={onClick}>
      <h3>{name}</h3>
    </div>
  );
};

export default TeamCard;
